<script lang="ts">
	import type { SbImage } from '$lib/storyblok/types';
	import Image from '$lib/storyblok/components/image.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';

	interface Props {
		content: ISbStoryData<{
			text: string;
			image: SbImage;
		}>['content'];
		index: number;
	}

	let { content, index }: Props = $props();
</script>

<div
	use:editable={content}
	class="relative aspect-2/3 h-full w-full overflow-hidden rounded-[20px] lg:aspect-3/2 lg:rounded-3xl"
>
	<Image
		wrapperClass="h-full w-full"
		class="h-full w-full object-cover"
		src={content.image.filename}
		alt={content.image.alt}
		title={content.image.title}
		width={1280}
		sizes={{ 1024: { width: 2092 } }}
	/>

	<div
		class="text-container absolute bottom-0 left-0 z-10 w-full text-balance p-6 text-white lg:p-8"
	>
		<p class="text-[20px]/[140%] tracking-[-.2px] lg:text-[24px]/[140%] lg:tracking-[-.24px]">
			{content.text}
		</p>
	</div>
	<div
		class="absolute left-0 top-0 z-10 p-5 font-serif text-[64px]/[100%] tracking-[-1.28px] text-white lg:p-8 lg:text-[96px]/[100%] lg:tracking-[-1.92px]"
	>
		{index + 1}
	</div>
</div>

<style lang="scss">
	div.text-container {
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
	}
</style>
